<template>
    <div  style="height: 300px;">
        <div :id="id_name" style="height: 100%;width: 100%"></div>
    </div>
</template>

<script>

import {  useHead } from "@vueuse/head"
export default {
    props: {
        address: {
            type: Object,
            default: function () {
                return {}
            }
        },
        latitude: {
            type: Number,
            default: 55.01657628017477
        },
        longitude: {
            type: Number,
            default: -7.309233337402361
        },
        center_latitude: {
            type: Number,
            default: 55.01657628017477
        },
        center_longitude: {
            type: Number,
            default: -7.309233337402361
        },
        zoom: {
            type: Number,
            default: 10
        }
    },
    watch: {
        address: function (val) {
        },
    },

    data(){
        return {
            // lat: this.latitude,
            // lng: this.longitude,
            markers : [],
            map : null,
            currentMarker : null,
            isOnCreating : true,
            id_name : null,
            callback_name : null,
        }
    },
    created() {

        this.callback_name = "initMap" +  this.generateRandomString(10);
        useHead({
            script: [
                {
                    src: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDcl_4E5iBaAR4bUuZePK3MIL-pO_oDoCA&callback=' + this.callback_name + '&v=weekly&language=ar',
                    defer: true
                },
            ],
        })

        this.id_name = "map-container" +  Math.random();
        console.log( 'created' );
        console.log( this.id_name );
    },
    mounted(){
        const self = this;
        console.log( this.callback_name );

        window[this.callback_name] = function () {

            console.log( 'in callback' );
            console.log( self.id_name );
            console.log( self.callback_name );
            // Set coordinates
            let myLatlng = new google.maps.LatLng(self.latitude ?? self.center_latitude, self.longitude ?? self.center_longitude);
            // Options
            let mapOptions = {
                zoom: self.zoom,
                center: myLatlng
            };

            console.log('map');
            console.log(self.id_name);
            // Apply options
            self.map = new google.maps.Map(document.getElementById(self.id_name), mapOptions);


            if(
                self.latitude
                &&
                self.longitude
            ){

                let _Location = new google.maps.LatLng(self.latitude, self.longitude);
                self.addMarker(_Location);


            }

            google.maps.event.addListener(self.map, 'click', function(event) {

                console.log(event.latLng);
                self.addMarker(event.latLng);
            });

            // google.maps.event.addListener(map, "center_changed", function() {
            //     let lat = map.getCenter().lat();
            //     let lon = map.getCenter().lng();
            //     let newLatLng = {lat: lat, lng: lon};
            //     marker.setPosition(newLatLng);
            //
            //     self.$emit('locationUpdated', newLatLng)
            // });

        };

    },
    methods :{
        generateRandomString(length) {
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let result = '';

            for (let i = 0; i < length; i++) {
                const randomIndex = Math.floor(Math.random() * characters.length);
                result += characters.charAt(randomIndex);
            }

            return result;
        },
        // setMapOnAll(map) {
        // },
        geocodeLatLng(position) {
            const self = this;
            const geocoder = new google.maps.Geocoder();
            // const infowindow = new google.maps.InfoWindow();

            const latlng = {
                lat: position.lat(),
                lng: position.lng(),
            };

            geocoder
                .geocode({ location: latlng })
                .then((response) => {
                    if (response.results[0]) {
                        // self.map.setZoom(11);
                        self.setAdress( response.results[0] )
                        // infowindow.setContent(response.results[0].formatted_address);
                        // infowindow.open(self.map, self.currentMarker);
                    }
                })
                .catch((e) => console.log("Geocoder failed due to: " + e));
        },
        setAdress (result) {

            let address = [];
            for (var i = 0; i < result?.address_components.length; i++ ) {
                const component = result?.address_components[i];


                if(component?.types?.includes('country')){
                    address['country'] = { 'long_name' : component?.long_name  , 'short_name' : component?.short_name };
                }

                if(component?.types?.includes('plus_code')){
                    address['plus_code'] = { 'long_name' : component?.long_name  , 'short_name' : component?.short_name };
                }

                if(component?.types?.includes('administrative_area_level_3')){
                    address['administrative_area_level_3'] = { 'long_name' : component?.long_name  , 'short_name' : component?.short_name };
                }

                if(component?.types?.includes('administrative_area_level_2')){
                    address['administrative_area_level_2'] = { 'long_name' : component?.long_name  , 'short_name' : component?.short_name };
                }

                if(component?.types?.includes('administrative_area_level_1')){
                    address['administrative_area_level_1'] = { 'long_name' : component?.long_name  , 'short_name' : component?.short_name };
                }
                if(component?.types?.includes('street_number')){
                    address['street_number'] = { 'long_name' : component?.long_name  , 'short_name' : component?.short_name };
                }
                if(component?.types?.includes('route')){
                    address['route'] = { 'long_name' : component?.long_name  , 'short_name' : component?.short_name };
                }
                if(component?.types?.includes('sublocality_level_1')){
                    address['sublocality_level_1'] = { 'long_name' : component?.long_name  , 'short_name' : component?.short_name };
                }
                if(component?.types?.includes('locality')){
                    address['locality'] = { 'long_name' : component?.long_name  , 'short_name' : component?.short_name };
                }
            }

            this.$emit('addressUpdated', address,this.isOnCreating);
            this.isOnCreating = false;

        },
        clearMarkers () {
            const self = this;
            for (var i = 0; i < self.markers.length; i++ ) {
                self.markers[i].setVisible(false);
            }
            self.markers = [];
        },
        addMarker (position) {
            this.clearMarkers();
            this.currentMarker = new google.maps.Marker({
                position: position,
                map: this.map
            });

            this.$emit('locationUpdated', {
                lat: position.lat(),
                lng: position.lng(),
            });

            this.markers.push(this.currentMarker);
            this.geocodeLatLng(position);
        }
    }
}
</script>
